import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { queueEzCommand } from 'utils/ezoic/queueEzCommand'

/**
 * EzoicRouteHandler component for managing Ezoic ads during SPA navigation.
 * Follows Ezoic's SPA integration guidelines:
 * https://support.ezoic.com/kb/article/how-to-integrate-ezoic-standalone-on-a-single-page-application
 *
 * This component listens to Next.js router events and destroys ads before navigation.
 * Ad reinitialization is handled by individual EzoicAd components when they mount on the new page.
 */

// CONSTANTS
const ROUTE_CHANGE_START_EVENT = 'routeChangeStart' as const

export const EzoicRouteHandler = () => {
  const router = useRouter()

  useEffect(() => {
    const handleRouteChangeStart = () => {
      queueEzCommand((ez) => {
        if (typeof ez.destroyAll === 'function') {
          ez.destroyAll()
        }
      })
    }

    router.events.on(ROUTE_CHANGE_START_EVENT, handleRouteChangeStart)

    return () => {
      router.events.off(ROUTE_CHANGE_START_EVENT, handleRouteChangeStart)
    }
    // router.events is stable and doesn't change between renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
